<template>
  <!-- Send Completed -->
  <div class="flies-step sending-flies">
    <div class="d-flex align-items-center mb-2">
      <div>
        <h5 class="mb-1">{{ title }}</h5>
      </div>
    </div>
    <div class="sending-cont">
      <div class="text-center pt-5">
        <div>
          <img src="images/transmore.png" alt="" width="80px" />
        </div>
        <h6 class="my-2">{{ clientName }}</h6>
      </div>
      <div class="py-4">
        <div class="d-flex justify-content-between align-items-center small">
          <span
            >Total {{ filesInfo.total_num }} files,
            {{ fileLengthFormat(filesInfo.total_size) }}</span
          >
          <a
            href="#close-sending"
            data-toggle="modal"
            class="btn btn-outline-primary px-4"
            @click="done()"
            >Done</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fileLengthFormat } from "../../../utils/Helpers";

export default {
  name: "MyCompleted",
  data() {
    return {
      statusInfo: [
        "None",
        "Connection Succeeded",
        "Sending",
        "Send Succeeded",
        "Send Failed",
        "Send Cancel",
        "Receive Succeeded",
        "Receive Failed",
        "Receive Cancel"
      ]
    };
  },
  model: {
    prop: "transfer"
  },
  props: ["transfer"],
  computed: {
    filesInfo() {
      // 这里计算属性直接返回filesInfo，而不是filesInfo下的属性是因为total_size和total_num的改变无法触发更新事件
      return this.transfer.filesInfo;
    },
    clientName() {
      if (this.transfer.upload_client_name) {
        return "From " + this.transfer.upload_client_name;
      }
      if (this.transfer.receive_client_name) {
        return "To " + this.transfer.receive_client_name;
      }
      return "";
    },
    title() {
      return this.statusInfo[this.transfer.status];
    }
  },
  methods: {
    fileLengthFormat(size) {
      return fileLengthFormat(size);
    },
    done() {
      this.transfer.step = 1;
    }
  }
};
</script>

<style scoped></style>
